<template>
  <div class="scene signup flex-r">
    <div class="section size-50" />

    <div id="step-container" class="size-40">
      <div class="signup-form-bg shadow-large">
        <h1>
          Скачайте и подпишите договор
        </h1>

        <p>
          Прежде чем перейти к оплате и начать пользоваться всеми возможностями нашего Сервиса, пожалуйста, ознакомьтесь
          с условиями представленного Лицензионного договора (текст договора также расположен на нашем сайте:
          <a href="https://justreserve.me/legal/license/" target="_blank">https://justreserve.me/legal/license</a>), в
          котором подробно описано, каким образом мы будем с Вами сотрудничать, а также какими взаимными правами и
          обязанностями обладаете вы и ООО «Джаст Резерв» при использовании Сервиса.
        </p>

        <a
          :href="downloadContractLink"
          target="_blank"
          class="button primary"
        >
          <span class="text">
            Скачать договор
          </span>
        </a>

        <h2 style="margin-top:100px;">
          Если вы согласны со всеми условиями и готовы начать сотрудничество, просим:
        </h2>

        <p>
          <span class="legal-ul-number">—</span>

          подписать договор, который представлен ниже в pdf-форме (тест договора также будет направлен на ранее
          указанный вами адрес электронной почты). При подписании договора убедитесь, что все ваши данные отображены
          верно, а также введите самостоятельно недостающую информацию о вас.
        </p>

        <p>
          Договор следует подписать на каждой странице и проставить печать (при ее наличии) в разделе реквизиты сторон.
        </p>

        <p>
          <span class="legal-ul-number">—</span>
          каждую страницу лицензионного договора отсканировать и прикрепить на данной странице, нажав кнопку «загрузить
          документ» или перетащив в выделенное поле.
        </p>

        <p>
          Если у вас нет возможности сделать скан и вы намерены сфотографировать страницы договора, просим, сделать это
          качественно и читаемо, в чем вам может помочь приложение
          <a
            href="https://www.google.com/search?q=Microsoft+Office+Lens&oq=Microsoft+Office+Lens"
            target="_blank"
          >
            Microsoft Office Lens
          </a>.
        </p>


        <vue-dropzone
          ref="dropzone"
          id="dropzone"
          :options="dropzoneOptions"
          :useCustomSlot="true"
          class="f-input size-100"
          :class="{ error: $v.selectedDocuments.$error }"
          @vdropzone-success="handleDropzoneFileSuccessUploaded"
          @vdropzone-removed-file="handleDropzoneFileWasRemoved"
        >
          <div class="dz-message-image">
            <img
              src="/img/svg/docs-placeholder.svg"
            >
          </div>

          <div class="dz-message-header">
            Перетащите сюда подписанные документ, или воспользуйтесь <br>
            файловым менеджером
          </div>

          <div class="dz-message-desc">
            Поддерживаемые форматы: PDF, JPG, PNG, BMP.
          </div>

          <button class="button primary">
            <span class="text">Загрузить документ</span>
          </button>

          <div
            v-if="$v.selectedDocuments.$error && !$v.selectedDocuments.required"
            class="f-input-text"
          >
            Документ, подтверждающий личность, обязателен
          </div>
        </vue-dropzone>

        <h2 style="margin-top:100px;">
          Если вы не готовы продолжать сотрудничество на условиях Лицензионного договора, пожалуйста, прекратите
          процедуру регистрации и не переходите к разделу оплаты.
        </h2>

        <p>
          Ни одно из ваших действий не должно привести к нарушению действующего законодательства, прав и законных
          интересов как нашей организации, так прав и законных интересов иных лиц.
        </p>


        <div class="signup-form-buttons flex-r">
          <div class="section size-100 txt-algn-r">
            <div
              class="button primary"
              :class="{ disabled: $v.$invalid }"
              @click="setSignedContract"
            >
              <div class="text">
                Следующий шаг
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section size-10" />
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone';
import cloneDeep from 'lodash.clonedeep';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'ContractSigningStep',
  validations: {
    selectedDocuments: {
      required
    }
  },
  components: {
    vueDropzone
  },
  props: {
    selectedProjectId: {
      type: String,
      required: true
    },
    documents: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedDocuments: cloneDeep(this.documents),
      dropzoneOptions: {
        url: this.$generateAbsolutePath('/file/upload'),
        thumbnailWidth: 150,
        addRemoveLinks: true
      }
    };
  },
  computed: {
    downloadContractLink() {
      return this.$generateAbsolutePath(`/project/agreement/upload/${this.selectedProjectId}`);
    }
  },
  mounted() {
    for (let index = 0; index < this.documents.length; index++) {
      const image = this.documents[index];

      this.$refs.dropzone.manuallyAddFile(
        image.file,
        this.$generateAbsolutePath(image.path)
      );
    }
  },
  methods: {
    handleDropzoneFileSuccessUploaded(file, response) {
      this.selectedDocuments.push({
        ...response,
        file
      });
    },
    handleDropzoneFileWasRemoved(removedFile) {
      const imageIndex = this.selectedDocuments.findIndex(({ file }) => file === removedFile);

      if (imageIndex !== -1) {
        this.selectedDocuments.splice(imageIndex, 1);
      }
    },
    setSignedContract() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit('next', cloneDeep(this.selectedDocuments));
      }
    },
    emitBackEvent() {
      this.$emit('back', cloneDeep(this.selectedDocuments));
    }
  }
}
</script>
